"use client";

import { createContext, useContext, type ReactNode } from "react";

interface VariableContextValue {
  allowBlockEnrollment: boolean;
}

const VariableContext = createContext<VariableContextValue>({
  allowBlockEnrollment: true,
});

export function VariableContextProvider({
  allowBlockEnrollment = true,
  children,
}: {
  allowBlockEnrollment?: boolean;
  children: ReactNode;
}) {
  return (
    <VariableContext value={{ allowBlockEnrollment }}>
      {children}
    </VariableContext>
  );
}

export function useVariableContext(): VariableContextValue {
  return useContext(VariableContext);
}
